import React from "react";

export const LazyRegistriesPage = React.lazy(() => import("./index"));
